import { render, staticRenderFns } from "./ContentSelectorDrag.vue?vue&type=template&id=72fa75cf&scoped=true&"
import script from "./ContentSelectorDrag.vue?vue&type=script&lang=ts&"
export * from "./ContentSelectorDrag.vue?vue&type=script&lang=ts&"
import style0 from "./ContentSelectorDrag.vue?vue&type=style&index=0&id=72fa75cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa75cf",
  null
  
)

export default component.exports